import React from 'react';
import Accounts_Comp from '../../Components/Accounts/Accounts';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function Contacts() {
  return (
    <Dashboard_Comp>
    <Accounts_Comp />
    </Dashboard_Comp>
  )
}

export default Contacts;